import React, { useState } from 'react';
import { Input, Tabs } from 'antd';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const { TabPane } = Tabs;
const { TextArea } = Input;

export default function TitleContent({
  value = {}, onChange, onChangeTabs, onEdit, panes, onFocus,
}) {
  const [title, setTitle] = useState({});
  const [content, setContent] = useState({});
  const [contentWeb, setContentWeb] = useState({});
  const [countWordsTitle, setCountWordsTitle] = useState(0);

  const triggerChange = (changedValue) => {
    if (onChange) {
      onChange({
        title,
        content,
        contentWeb,
        ...value,
        ...changedValue,
      });
    }
  };

  const onTitleChange = (e) => {
    setCountWordsTitle(e.target.value.length);
    const newTitle = e.target.value;
    const languageOfTitle = e.target.name;
    if (!('title' in value)) {
      setTitle({ ...value.title, [languageOfTitle]: newTitle });
    }
    triggerChange({
      title: { ...value.title, [languageOfTitle]: newTitle },
    });
  };

  const onContentWebChange = (event, editor, language) => {
    const data = editor.getData();
    const newContentWeb = data;
    const languageOfContentWeb = language;
    if (!('contentWeb' in value)) {
      setContentWeb({ ...value.contentWeb, [languageOfContentWeb]: newContentWeb });
    }
    triggerChange({
      contentWeb: { ...value.contentWeb, [languageOfContentWeb]: newContentWeb },
    });
  };

  const onContentChange = (e) => {
    const newContent = e.target.value;
    const languageOfContent = e.target.name;
    if (!('content' in value)) {
      setContent({ ...value.content, [languageOfContent]: newContent });
    }
    triggerChange({
      content: { ...value.content, [languageOfContent]: newContent },
    });
  };

  return (
    <Tabs
      hideAdd
      onChange={onChangeTabs}
         // activeKey={this.state.activeKey}
      type="editable-card"
      onEdit={onEdit}
      defaultActiveKey="0"
    >
      {panes.map((pane) => (
        <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
          <span>Tiêu đề</span>
          <Input
            onBlur={() => onFocus(false)}
            onFocus={() => onFocus(true)}
            rows={1}
            maxLength={100}
            name={pane.title}
            value={value.title[pane.title] || title[pane.title] || []}
            onChange={onTitleChange}
          />
          <p className="mb-small text-right">
            {' '}
            {countWordsTitle}
            /100
          </p>
          <span>Nội dung trên điện thoại</span>
          <TextArea
            name={pane.title}
            onBlur={() => onFocus(false)}
            onFocus={() => onFocus(true)}
            rows={4}
            value={value.content[pane.title] || content[pane.title] || []}
            onChange={onContentChange}
            className="mb-small"
          />
          <span>Nội dung trên web</span>
          <CKEditor
            config={{
              link: {
                addTargetToExternalLinks: true,
              },
              removePlugins: ['ImageUpload', 'MediaEmbed'],
              toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
            }}
            editor={ClassicEditor}
            data={value.contentWeb[pane.title] || contentWeb[pane.title] || []}
                  // onBlur={() => onFocus(false)}
                  // onFocus={() => onFocus(true)}
            onChange={(event, editor) => onContentWebChange(event, editor, pane.title)}
          />
        </TabPane>
      ))}
    </Tabs>
  );
}
